"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const internal_1 = require("./internal");
exports.isValid = (address) => {
    if (address.indexOf(`${internal_1.AddressPrefix}-`) === 0) {
        address = address.substr(6);
    }
    const codeword = internal_1.initialCodeword.slice();
    let codewordLength = 0;
    for (let i = 0; i < address.length; i++) {
        const pos = internal_1.alphabet.indexOf(address.charAt(i));
        if (pos <= -1 || pos > internal_1.alphabet.length) {
            continue;
        }
        if (codewordLength > 16) {
            return false;
        }
        const codeworkIndex = internal_1.cwmap[codewordLength];
        codeword[codeworkIndex] = pos;
        codewordLength++;
    }
    if (codewordLength !== 17) {
        return false;
    }
    let sum = 0;
    for (let i = 1; i < 5; i++) {
        let t = 0;
        for (let j = 0; j < 31; j++) {
            if (j > 12 && j < 27) {
                continue;
            }
            let pos = j;
            if (j > 26) {
                pos -= 14;
            }
            t ^= internal_1.gmult(codeword[pos], internal_1.gexp[(i * j) % 31]);
        }
        sum |= t;
    }
    return (sum === 0);
};
exports.isBurstAddress = (address) => {
    const addressRegExp = new RegExp(`${internal_1.AddressPrefix}\-[A-Z0-9]{4}\-[A-Z0-9]{4}\-[A-Z0-9]{4}\-[A-Z0-9]{5}(-\w+)?`, 'i');
    if (!addressRegExp.test(address)) {
        return false;
    }
    const index = address.lastIndexOf('-');
    const extension = address.substr(index + 1);
    const hasExtension = extension.length > 5;
    address = hasExtension ? address.substr(0, index) : address;
    return exports.isValid(address);
};
//# sourceMappingURL=isBurstAddress.js.map